import { Button, GenericSuspense, List, useUrlParamsValueToString } from '@bsm/component';
import { TSignatory } from '@bsm/graphql';
import React from 'react'
import { Link, Outlet } from 'react-router-dom';
import { SignatoryListItem } from '../components/SignatoryListItem';
import SignatoryListQuery from '../queries/SignatoryListQuery';

export default function InvoiceListViewerSignatoriesContainer() {
    const urlParams = useUrlParamsValueToString();
    
  return (
      <div>
          <div className="flex justify-between mb-4">
              <h3 className="font-semibold">Signatories</h3>
              <Link to={`new?${urlParams}`}>
                  <Button
                      className="btn-default"
                      startIcon="fa-solid fa-plus"
                      label="Add"
                  />
              </Link>
          </div>

          <List
              id={SIGNATORY_LIST_ID}
              selection={false}
              isUrlParamsState={false}
              GQLRequest={SignatoryListQuery}
              defaultFilter={{
                  pageSize: 50,
                  page: 0,
                  sort: [{ value: "createdAt", sort: "DESC" }],
              }}
              onRenderRow={(row: TSignatory) => (
                  <SignatoryListItem {...row} />
              )}
          />

          <GenericSuspense>
              <Outlet />
          </GenericSuspense>
      </div>
  );
}

export const SIGNATORY_LIST_ID = "invoice-signatory-list"; 
